import { COMPANY } from '../store/seed-named';
import { CredentialField } from './views.models';

/** Illustrative: each company asks for different fields; the producer code is always requested on top. */
const USER_PASSWORD: CredentialField[] = [
  { key: 'user', label: 'Usuario', secret: false },
  { key: 'password', label: 'Clave', secret: true },
];

export const CREDENTIAL_FIELDS: Record<string, CredentialField[]> = {
  [COMPANY.plata]: USER_PASSWORD,
  [COMPANY.austral]: [{ key: 'apiKey', label: 'API key', secret: true }],
  [COMPANY.federal]: [...USER_PASSWORD, { key: 'organizerCode', label: 'Código de organizador', secret: false }],
  [COMPANY.nexo]: USER_PASSWORD,
  [COMPANY.pampa]: [{ key: 'token', label: 'Token', secret: true }],
  [COMPANY.litoral]: USER_PASSWORD,
};

export const SECRET_MASK = '••••••••';
